import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  useTheme,
  useMediaQuery,
  DialogProps,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

export type LargeDialogProps = {
  title: string;
  actions?: React.ReactNode;
  children?: React.ReactNode;
  onClose: () => void;
  onSubmit?: (e: React.FormEvent<HTMLFormElement>) => void;
} & Omit<DialogProps, "open">;

const LargeDialog: React.FC<LargeDialogProps> = (props) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const { onClose, title, children, actions, onSubmit, sx, ...dialogProps } = props;

  return (
    <Dialog
      open={true}
      scroll="paper"
      fullScreen={isSmallScreen}
      onClose={onClose}
      {...(onSubmit && {
        component: "form",
        onSubmit: onSubmit as React.FormEventHandler<HTMLElement>,
      })}
      sx={{ ".MuiDialog-paper": { margin: 0 }, ...sx }}
      {...dialogProps}
    >
      <DialogTitle>{title}</DialogTitle>

      <IconButton
        onClick={onClose}
        sx={{ position: "absolute", right: 8, top: 12, color: "grey.500" }}
      >
        <CloseIcon />
      </IconButton>

      {children && (
        <DialogContent dividers sx={{ display: "grid", gap: 1 }}>
          {children}
        </DialogContent>
      )}

      {actions && (
        <DialogActions
          disableSpacing
          sx={(theme) => ({
            gap: theme.spacing(1),
            [theme.breakpoints.down("sm")]: {
              flexDirection: "column-reverse",
              alignItems: "stretch",
            },
          })}
        >
          {actions}
        </DialogActions>
      )}
    </Dialog>
  );
};

export default LargeDialog;
